import React from 'react'
import CanvasLogo from '../../../assets/icons/canvas-logo.svg'
import SuspensionModal from './SuspensionModal'
import { LevelTrackerSection, RequirementsSection } from './ProgressTrackerContent'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  Container,
  SuspendedContentWrapper,
  DisabledOverlay,
  Header,
  TitleSection,
  Title,
  AssociateHeader,
  ProgramInfoItem,
  ProgramInfoLabel,
  ProgramInfoLink,
  PortalButton,
  PortalButtonText
} from './Styles/ProgressTracker.styles'

const SuspendedProgressTracker = ({
  levels,
  currentLevel,
  levelCompletionDate,
  patRequirementWithWarning,
  additionalRequirements,
  activeLevel,
  shouldShowPATWarning,
  shouldShowLevelCompleteBanner,
  shouldShowAdditionalRequirements,
  onLevelClick,
  programHistory,
  currentLevelCode,
  levelState
}) => {
  const { latestProgram } = useMembershipJourneyContext()
  const careerPath = latestProgram?.careerPath
  
  return (
    <Container>
      <Header>
        <TitleSection>
          <Title>My Path to Membership</Title>
          {careerPath && (
            <ProgramInfoLink href="https://www.pga.org/membership/associate-program/path-to-membership-articles/career-paths/" target="_blank" rel="noopener noreferrer">
              {careerPath} ›
            </ProgramInfoLink>
          )}
        </TitleSection>
        {currentLevelCode && currentLevelCode !== 'F0' && (
          <AssociateHeader>
            <ProgramInfoItem>
              <ProgramInfoLabel>Associate Program</ProgramInfoLabel>
              <ProgramInfoLink href="https://www.pga.org/membership/associate-program/" target="_blank" rel="noopener noreferrer">Details ›</ProgramInfoLink>
            </ProgramInfoItem>
          </AssociateHeader>
        )}
      </Header>

      <SuspendedContentWrapper>
        <DisabledOverlay>
        <LevelTrackerSection 
          levels={levels}
          isSuspended
          activeLevel={activeLevel}
          programHistory={programHistory}
          levelState={levelState}
        />
        </DisabledOverlay>

        <DisabledOverlay>
          <RequirementsSection
            shouldShowLevelCompleteBanner={shouldShowLevelCompleteBanner}
            currentLevel={currentLevel}
            levelCompletionDate={levelCompletionDate}
            patRequirementWithWarning={patRequirementWithWarning}
            additionalRequirements={additionalRequirements}
            activeLevel={activeLevel}
            shouldShowPATWarning={shouldShowPATWarning}
            shouldShowAdditionalRequirements={shouldShowAdditionalRequirements}
            onLevelClick={onLevelClick}
          />
        </DisabledOverlay>

        <SuspensionModal />
      </SuspendedContentWrapper>

      <PortalButton>
        <img src={CanvasLogo} alt="Canvas Logo" />
        <PortalButtonText>Education Portal</PortalButtonText>
      </PortalButton>
    </Container>
  )
}

export default SuspendedProgressTracker

